type EnergyIconProps = {
    color?: string;
  }

export const EnergyNobreakIcon = ({ color }: EnergyIconProps): JSX.Element => (
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.27109 3.625L5.76483 8.68508C5.55376 8.9897 5.44822 9.14201 5.45456 9.26861C5.46008 9.37887 5.51429 9.48111 5.60274 9.54809C5.70429 9.625 5.89058 9.625 6.26316 9.625H9.27109V13.375L12.7773 8.31492C12.9884 8.0103 13.094 7.85799 13.0876 7.73139C13.0821 7.62113 13.0279 7.51889 12.9394 7.45191C12.8379 7.375 12.6516 7.375 12.279 7.375H9.27109V3.625Z" stroke="#363BC4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.27109 16C13.4459 16 16.8303 12.6421 16.8303 8.5C16.8303 4.35786 13.4459 1 9.27109 1C5.09627 1 1.71191 4.35786 1.71191 8.5C1.71191 12.6421 5.09627 16 9.27109 16Z" stroke="#363BC4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
